import { render, staticRenderFns } from "./WorkplaceAdvanced.vue?vue&type=template&id=0074088d&scoped=true&"
import script from "./WorkplaceAdvanced.vue?vue&type=script&lang=ts&"
export * from "./WorkplaceAdvanced.vue?vue&type=script&lang=ts&"
import style0 from "./WorkplaceAdvanced.vue?vue&type=style&index=0&id=0074088d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0074088d",
  null
  
)

export default component.exports